<template>
    <div class="row my-5 div-history">
        <div class="col-12">
            <legend>{{ translate.labelVideosDown }}</legend>
            <!-- <span class="subtitle">{{ translate.subLabelVideosDown }}</span> -->
        </div>
        <div class="col-lg-12">
            <loading v-model:active="loading" :is-full-page="false" :opacity="0.5" color="#b20000" />
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">{{ translate.orderStatus }}</th>
                        <th scope="col">{{ translate.orderPlanName }}</th>
                        <th scope="col">{{ translate.orderMethodName }}</th>
                        <th scope="col">{{ translate.orderValue }}</th>
                        <th scope="col">{{ translate.orderDate }}</th>
                    </tr>
                </thead>
                <tbody v-if="orders.length > 0">
                    <tr v-for="order in orders" :key="order.id">
                        <th scope="row">{{ order.status }}</th>
                        <td>{{ order.planName }}</td>
                        <td>{{ order.methodName }}</td>
                        <td>{{ locale === 'pt-br' ? 'R$' : 'US$' }} {{order.value}}</td>
                        <td>{{ order.orderDate }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/mycredits'
import Loading from 'vue-loading-overlay';
import router from "router"
import api from '../../api'
export default defineComponent({
    name: 'HistoryCredits',
    computed: {
        ...mapState(localeStore, ['locale']),
        translate: function () {
            this.getHistory()
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        }
    },
    components: {
        Loading,
    },
    data() {
        return {
            orders: [],
            loading: false
        }
    },
    methods: {
        redirect(name) {
            router.push({
                name,
                params: {
                    locale: this.locale
                }
            })
        },
        async getHistory() {
            this.loading = true
            api.get('v1/mycredits/getHistorico?locale=' + this.locale).then(({ data }) => {
                this.orders = data
            })
                .catch(error => console.log(error))
                .finally(() => this.loading = false)
        }
    }
})
</script>
<style scoped lang="css">
legend {
    font-family: 'Roboto-Medium';
    line-height: 28px;
    font-size: 24px;
    color: #b40909;
    margin-bottom: 15px;
}

.subtitle {
    font-family: 'Roboto-Regular';
    line-height: 19px;
    font-size: 16px;
}

.table> :not(caption)>*>* {
    background-color: #fff;
}

.table {
    margin-top: 32px;
    margin-left: 16px;
}

thead>tr>th {
    font-family: 'Roboto-Regular';
    font-size: 16px;
    line-height: 19px;
    color: #999;
    padding: 23px 16px;
}

tbody>tr>td {
    font-family: 'Exo-2';
    font-size: 18px;
    line-height: 18px;
    color: #000;
    padding: 23px 16px;
}

tbody>tr>th {
    font-family: 'Exo-2';
    font-size: 18px;
    line-height: 18px;
    color: #000;
    padding: 23px 16px;
}

thead,
tbody,
tfoot,
tr,
td,
th {
    border-color: #ddd;
    border-style: solid;
    border-width: 1px;
}

.div-history {
    margin-left: 15px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .div-history {
        overflow: auto;
    }

    .subtitle {
        margin-left: unset;
    }
}
</style>